import styled from "styled-components";

const GroupImage = styled.img<{ $size?: number }>`
  height: ${(p) => p.$size || 60}px;
  width: ${(p) => p.$size || 60}px;
  border-radius: 8px;
  object-fit: cover;
`;

export default GroupImage;
